var naturesIta = {
    "100": "Ardita",        // Hardy
    "101": "Schiva",        // Lonely
    "102": "Audace",        // Brave
    "103": "Decisa",        // Adamant
    "104": "Birbona",       // Naughty
    "105": "Sicura",        // Bold
    "106": "Docile",        // Docile
    "107": "Placida",       // Relaxed
    "108": "Scaltra",       // Impish
    "109": "Fiacca",        // Lax
    "110": "Timida",        // Timid
    "111": "Lesta",         // Hasty
    "112": "Seria",         // Serious
    "113": "Allegra",       // Jolly
    "114": "Ingenua",       // Naive
    "115": "Modesta",       // Modest
    "116": "Mite",          // Mild
    "117": "Quieta",        // Quiet
    "118": "Ritrosa",       // Bashful
    "119": "Ardente",       // Rash
    "120": "Calma",         // Calm
    "121": "Gentile",       // Gentle
    "122": "Vivace",        // Sassy
    "123": "Cauta",         // Careful
    "124": "Bizzarra"       // Quirky
};
export default naturesIta;